<template>
  <div>
    <x-grid
        :id="'formList'"
        :rowId="rowId"
        :pager-config="pagerConfig"
        :form-config="formConfig"
        :url="url"
        :columns="columns"
        :checkbox-config="checkboxConfig"
        :toolbar-config="toolbarConfig"
        :print-config="printConfig"
        :export-config="exportConfig"
        ref="grid"
        :cellClick="chooseRow"
        :cellDbClick="updateRow"
        @toolbar-addData="addRow"
        @toolbar-delData="delRow('删除后，已添加到话术库中的关键词也一起删除')"
    >
      <template v-slot:[toolbarConfig.templatelSlots]>
      </template>
    </x-grid>

    <!-- 详情页 -->
    <a-modal
        title="关键词"
        centered
        :closable="false"
        :footer="null"
        :maskClosable="false"
        :visible="editModalVisible"
        :width="600"
    >
      <!-- 绑定子组件事件时，如果只写方法名，则子组件$emit的参数会直接传递给方法，所以应该明确指定参数 -->
      <detailForm
          :rowId="editRowId"
          v-if="editModalVisible"
          ref="form"
          @cancelled="closeEdit()"
          @saved="closeEdit(true)"
      >
      </detailForm>
    </a-modal>

  </div>
</template>

<script>
import XGrid from "@/components/grid/XGrid";
import {GridMixin} from "@/utils/GridMixin";
import {formatter as fmt} from "@/utils/ebase-formatter";
import api from "@/services/api";
import {loadBaseCodeData} from "@/services/baseCodeSource";

console.info(fmt, loadBaseCodeData); //防止未用到报未定义错误 用到了可删除
import detailForm from "./keyWordsDetail";


const fac = XGrid.factory;

//列表接口
const url = api.answer.KEYWORDS;

//主键
const rowId = "keyWordsId";

//列
const columns = [
  fac.makeColumnCheckboxDefault(),
  fac.makeColumnSeqDefault(),
  fac.makeColumn("keyWordsName", "关键词", 240),
  fac.makeColumn("createDate", "创建时间", 240),
  fac.makeColumn("createUserName", "创建人", 240),
  fac.makeColumn("lastModifyDate", "最后修改日期", 240),
  fac.makeColumn("lastModifyUserName", "最后修改人", 240),
];

// 筛选条件
const formConfig = fac.makeFormConfig(columns, [
  {field: "keyWordsName"}
]);

//工具栏按钮
const toolbarConfig = fac.makeToolbarConfig({
  export: true,
  import: false,
  delData: true,
  addData: true,
  templatelSlots: "toolbarBtns",
});

//可编辑表格约束
const editRules = fac.makeEditRules(columns);
const printConfig = fac.makePrintConfig(columns);
const pagerConfig = fac.makePagerConfig();
const checkboxConfig = fac.makeCheckboxConfig(columns);

const popConfig = fac.makePopConfig(["password", "merchantsAuthorization"]);

export default {
  mixins: [GridMixin],
  authorize: {
    // addRow: "ADD",
    // updateRow: 'UPDATE',
    // delRow: 'DELETE',
    // importMethod:'IMPORT',
    // exportMethod:'EXPORT',
  },
  components: {
    detailForm,
  },
  computed: {},
  data() {
    return {
      popConfig,
      columns,
      rowId,
      url,
      formConfig,
      toolbarConfig,
      printConfig,
      checkboxConfig,
      editRules,
      pagerConfig,
      userIdList: []
    };
  },
  methods: {},
};
</script>

<style scoped>
</style>